
import AxiosClient from "../../../services/axios.services";

class NineBoxesServices {
  getNineBoxes = params =>
    AxiosClient.get("api/app/capacitacion_llenado_9cajas/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });
}

export default new NineBoxesServices();